import angular from 'angular';

angular.module('commonServices').filter('edit', function() {
  return function(value) {
    var editSign = '<i class="glyphicon glyphicon-pencil"></i>';

    if (value === null) return editSign;
    if (value === undefined) return editSign;
    if (value === '') return editSign;
    // empty guid
    if (value === '00000000-0000-0000-0000-000000000000') return editSign;
    // 4 whitespaces returns as well => Empty address
    if (value === '    ') return editSign;
    return value;
  };
});
